import type { Theme } from '@mui/material/styles';
import { SnackType } from '@/features/snacks/enums/SnackType';

export const getSnackBackgroundColor = (theme: Theme, type: SnackType) => {
  switch (type) {
    case SnackType.Error:
      return theme.palette.error.lightBackground;
    case SnackType.Warning:
      return theme.palette.warning.lightBackground;
    case SnackType.Info:
      return theme.palette.background.editModeInput;
    default:
      return theme.palette.success.lightBackground;
  }
};
